const endpoints = {
  requestExport: '/v1/exports/csv/create',
};

export default endpoints;
